import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const slides = [
  {
    id: "tao-1997",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20nostalgic%20Hong%20Kong%20harbour%20at%20dusk%20with%20warm%20peach%20and%20amber%20sky%2C%20soft%20neon%20reflections%20on%20water%2C%20film%20grain%20texture%2C%20romantic%20moody%20atmosphere%2C%20peach%20branch%20in%20foreground&width=1920&height=1080&seq=hero-tao1997&orientation=landscape",
    tag: "焦点影片",
    title: "蜜桃成熟时1997",
    subtitle: "甜中带涩的都市寓言 · 1997",
    description:
      "一段在夏夜短暂相遇、却绵延成漫长牵挂的爱情。三段式结构、雨夜与渡轮的视觉母题，构成九十年代港片最被低估的抒情篇章。",
    primaryTo: "/detail/tao-1997",
    primaryLabel: "查看影片详情",
    secondaryTo: "/features/plot-analysis",
    secondaryLabel: "阅读剧情解析",
  },
  {
    id: "chungking-1994",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20night%20city%20alley%20with%20warm%20amber%20neon%20signs%20and%20blurred%20motion%2C%20deep%20rose%20and%20teal%20accents%2C%20rainy%20reflections%2C%20moody%20urban%20atmosphere%2C%20film%20grain&width=1920&height=1080&seq=hero-chungking&orientation=landscape",
    tag: "经典重温",
    title: "重庆森林",
    subtitle: "罐头会过期 · 1994",
    description:
      "失恋的警察在便利店数着即将过期的凤梨罐头，快餐店的喧闹里，有人与人擦肩。九十年代最著名的都市孤独图景。",
    primaryTo: "/detail/chungking-1994",
    primaryLabel: "查看影片详情",
    secondaryTo: "/category",
    secondaryLabel: "浏览电影分类",
  },
  {
    id: "comrades-1996",
    image:
      "https://readdy.ai/api/search-image?query=two%20silhouettes%20riding%20a%20bicycle%20at%20golden%20hour%2C%20warm%20sepia%20and%20rose%20tones%2C%20soft%20sun%20flare%2C%20nostalgic%20cinematic%20mood%2C%20film%20grain%20texture&width=1920&height=1080&seq=hero-comrades&orientation=landscape",
    tag: "温暖推荐",
    title: "甜蜜蜜",
    subtitle: "异乡人 · 1996",
    description:
      "两个从内地来到香港的年轻人，在异乡街头相遇、相依又分离。横跨十年的时代变迁，写进小人物的三餐一饭。",
    primaryTo: "/detail/comrades-1996",
    primaryLabel: "查看影片详情",
    secondaryTo: "/guides",
    secondaryLabel: "浏览观影指南",
  },
];

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  const go = useCallback((next: number) => {
    setIndex((next + slides.length) % slides.length);
  }, []);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, []);

  const slide = slides[index];

  return (
    <section className="relative w-full h-[520px] md:h-[640px] -mt-16 md:-mt-20 overflow-hidden">
      {slides.map((item, itemIndex) => (
        <div
          key={item.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            itemIndex === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={item.image}
            alt={`${item.title} 影片海报`}
            title={`${item.title} - 经典电影介绍`}
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/60"></div>
        </div>
      ))}

      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-8">
          <div className="max-w-2xl animate-fade-up" key={slide.id}>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
              <i className="ri-bookmark-line"></i>
              {slide.tag}
            </span>
            <h1 className="mt-4 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              {slide.title}
            </h1>
            <p className="mt-3 text-sm md:text-base text-primary-200 tracking-wider">
              {slide.subtitle}
            </p>
            <p className="mt-4 text-sm md:text-base text-white/85 leading-relaxed max-w-xl">
              {slide.description}
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link
                to={slide.primaryTo}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                {slide.primaryLabel}
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to={slide.secondaryTo}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-white/50 text-white text-sm font-medium hover:bg-white/15 transition-colors whitespace-nowrap"
              >
                {slide.secondaryLabel}
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-0 right-0 z-10">
        <div className="w-full px-4 md:px-8 flex items-center justify-between">
          <div className="flex items-center gap-2">
            {slides.map((item, itemIndex) => (
              <button
                key={item.id}
                type="button"
                onClick={() => go(itemIndex)}
                aria-label={`切换到 ${item.title}`}
                className={`h-1.5 rounded-full transition-all cursor-pointer ${
                  itemIndex === index ? "w-8 bg-primary-400" : "w-3 bg-white/50 hover:bg-white/80"
                }`}
              ></button>
            ))}
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button
              type="button"
              onClick={() => go(index - 1)}
              aria-label="上一张"
              className="w-10 h-10 rounded-full border border-white/40 text-white flex items-center justify-center hover:bg-white/15 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <button
              type="button"
              onClick={() => go(index + 1)}
              aria-label="下一张"
              className="w-10 h-10 rounded-full border border-white/40 text-white flex items-center justify-center hover:bg-white/15 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}